import React, {useEffect, useState} from 'react';
import {
  Box,
  Button,
  Divider,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import DetectorTable from '../DetectorTable/DetectorTable.tsx';
import {useTheme} from '@mui/styles';
import {ArrowBack, ArrowForward} from '@mui/icons-material';
// import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
// import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs/index.js';
import {TagDataInstance, VehicleStatus} from 'pages/softPrio/types/index.ts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
// import {AppSettings} from 'config/appConfigs/appSettings.ts';
import SideBarTrainCard from './SideBarTrainCard.tsx';
import useFetchAllTags from 'pages/softPrio/hooks/useFetchAllTags.ts';

dayjs.extend(utc);
dayjs.extend(timezone);
interface SideBarProps {
  functionName: string;
  fetchedTags: TagDataInstance[] | undefined;
  onSelectedTram: (singleTram: VehicleStatus) => void;
  isFullScreenForTramDetail: (isFullScreen: boolean) => void;
  setProcessedTagsForApp: (trams: VehicleStatus[]) => void;
  processedTags: VehicleStatus[] | undefined;
  activeTram: VehicleStatus | undefined;
}

const Sidebar: React.FC<SideBarProps> = ({
  functionName,
  fetchedTags,
  onSelectedTram,
  isFullScreenForTramDetail,
  processedTags,
  activeTram,
}) => {
  const theme = useTheme(); // Access the theme
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [alarmType, setAlarmType] = useState('Alla typer');
  const [timeRange, setTimeRange] = useState('1W');
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [openPicker, setOpenPicker] = useState(false);
  const {data} = useFetchAllTags();
  // const [processedTags, setProcessedTags] = useState<VehicleStatus[]>();
  const [singleProcessedTag, setSingleProcessedTag] = useState<VehicleStatus | undefined>(
    activeTram,
  );

  const handleFullScreenToggle = () => {
    setIsFullScreen(!isFullScreen);
    isFullScreenForTramDetail(!isFullScreen);
  };

  useEffect(() => {
    setSingleProcessedTag(activeTram);
  }, [activeTram]);

  // const handleDateChange = (date: Date | null) => {
  //   setSelectedDate(date);
  // };
  // const getDistinctIds = (data: TagData): number[] => {
  //   const ids = new Set<number>();

  //   data.data.forEach((item) => {
  //     ids.add(item.eventData.old_vehicle_id);
  //   });

  //   return Array.from(ids);
  // };
  // const getDistinctObjects = (data: TagData): TagData[] => {
  //   const vehicleMap: Map<number, TagData> = new Map();

  //   data.data.forEach((item) => {
  //     const oldVehicleId = item.eventData.old_vehicle_id;
  //     const existingItem = vehicleMap.get(oldVehicleId);

  //     if (
  //       !existingItem ||
  //       new Date(item.eventData.server_timestamp) >
  //         new Date(item.eventData.server_timestamp)
  //     ) {
  //       vehicleMap.set(oldVehicleId, item);
  //     }
  //   });

  //   // Convert map values to an array and sort by detectionTime
  //   return Array.from(vehicleMap.values()).sort(
  //     (a, b) => new Date(b.detectionTime).getTime() - new Date(a.detectionTime).getTime(),
  //   );
  // };
  // Function to filter and calculate average rssi
  // Function to filter and calculate average rssi
  // Function to process data and get average counts of each status

  useEffect(() => {
    console.log(activeTram);
  }, [singleProcessedTag]);

  const togglePicker = () => {
    setOpenPicker(!openPicker);
  };

  const handleAlarmTypeChange = (event: React.ChangeEvent<{value: unknown}>) => {
    setAlarmType(event.target.value as string);
  };

  const handleTimeRangeChange = (event: React.ChangeEvent<{value: unknown}>) => {
    setTimeRange(event.target.value as string);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        padding: theme.spacing(2),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        width: isFullScreen ? '100%' : '33.33%',
        transition: 'width 0.3s ease',
      }}
    >
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{width: '100%'}}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography
            variant="h6"
            sx={{color: theme.palette.primary.main, fontWeight: 'bold'}}
          >
            SoftPrio
          </Typography>
          <Typography
            variant="h6"
            sx={{color: theme.palette.text.secondary, fontWeight: 'bold'}}
          >
            &gt;
          </Typography>
          {functionName == 'Underpresterande' || functionName == 'Värmekarta' ? (
            <>
              <Typography variant="h6" sx={{color: theme.palette.text.primary}}>
                {'Radiokvalitet'}
              </Typography>
              <Typography
                variant="h6"
                sx={{color: theme.palette.text.secondary, fontWeight: 'bold'}}
              >
                &gt;
              </Typography>
            </>
          ) : null}
          <Typography variant="h6" sx={{color: theme.palette.text.primary}}>
            {functionName}
          </Typography>
        </Stack>

        {singleProcessedTag && functionName == 'Radiokvalitet' && (
          <IconButton
            sx={{
              backgroundColor: theme.palette.warning.main,
              '&:hover': {backgroundColor: theme.palette.warning.dark},
            }}
            onClick={handleFullScreenToggle}
          >
            {isFullScreen ? (
              <ArrowBack sx={{color: theme.palette.text.primary}} />
            ) : (
              <ArrowForward sx={{color: theme.palette.text.primary}} />
            )}
          </IconButton>
        )}
      </Stack>

      <Divider sx={{backgroundColor: theme.palette.divider, mt: 1}} />

      {/* Filter Section */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{marginTop: theme.spacing(2), width: '100%'}}
        spacing={2}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Select
            sx={{
              color: theme.palette.text.primary,
              minWidth: '8em',
              height: '2.5rem',
              '& .MuiSvgIcon-root': {
                color: theme.palette.text.primary,
              },
            }}
            disableunderline
            value={alarmType}
            onChange={handleAlarmTypeChange}
            size="small"
          >
            <MenuItem value="Alla typer">Alla typer</MenuItem>
            <MenuItem value="Online">Online</MenuItem>
            <MenuItem value="off-line">Off-line</MenuItem>
          </Select>
          <Button
            onClick={() => setAlarmType('Alla typer')}
            size="small"
            style={{
              backgroundColor: theme.palette.warning.main,
              color: theme.palette.warning.contrastText,
              borderRadius: 20,
              padding: '2px 8px',
            }}
          >
            {alarmType} ✕
          </Button>
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          {/*<Typography>*/}
          {/*  {startDate && endDate*/}
          {/*    ? `${startDate.toLocaleDateString()} to ${endDate.toLocaleDateString()}`*/}
          {/*    : 'Select Date'}*/}
          {/*</Typography>*/}
          {/*<IconButton onClick={togglePicker}>*/}
          {/*  <EventIcon style={{fill: theme.palette.warning.main}} />*/}
          {/*</IconButton>*/}
        </Stack>
      </Stack>

      <Divider
        sx={{
          backgroundColor: theme.palette.divider,
          mb: 1,
          marginTop: theme.spacing(0.2),
        }}
      />

      <Stack direction="row" alignItems="start">
        <Box
          sx={{
            width: isFullScreen ? '33%' : '100%',
            maxWidth: '100%',
            borderRight: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box
            sx={{
              height: '100vh',
              backgroundColor: theme.palette.background.paper,
              padding: theme.spacing(1),
              borderRadius: theme.shape.borderRadius,
            }}
          >
            <SideBarTrainCard
              processedTags={processedTags!}
              selectedTag={singleProcessedTag}
              functionName={functionName}
              onSelectTag={(e) => {
                setSingleProcessedTag(e);
                onSelectedTram(e);
              }}
            />
          </Box>
        </Box>
        {isFullScreen && <DetectorTable singleProcessedTag={singleProcessedTag} />}
      </Stack>
    </Box>
  );
};

export default Sidebar;
